"use strict";

import {optionsFromCapabilities} from 'ol/source/WMTS';

/**
 * @classdesc
 * Interface für WMTS-Provider.
 *
 * @class
 * @extents gc.gis.GCWrappable
 * @memberof gc.gis.map
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {gc.gis.util.GCRequestManager} requestManager
 */
gc.gis.map.GCAbstractWMTSProvider = function(requestManager)
{
    gc.gis.GCWrappable.call(this);

    this.requestManager = requestManager;
};
gc.gis.map.GCAbstractWMTSProvider.prototype = Object.create(gc.gis.GCWrappable.prototype);

/**
 * Liefert das Capabilities des WMTS.
 *
 * @abstract
 * @public
 * @param {string} url WMTS-URL zum Laden des Capabilities
 * @param {function} onResponse Callback, die mit dem Capabilities als Parameter aufgerufen wird {@link gc.gis.format.GCWmtsCapabilities}
 * @throws {gc.gis.error.GCError} sofern das Capabilities-Dokument nicht geladen werden konnte
 */
gc.gis.map.GCAbstractWMTSProvider.prototype.getCapabilities = gc.gis.abstractMethod;

/**
 * Leitet eine Layerkonfiguration aus einem WMTS-Capabilities ab.
 *
 * @abstract
 * @public
 * @param {gc.gis.format.GCWmtsCapabilities} capabilities
 * @param {string} layerIdentifier
 * @param {Object} opt_options
 * @param {strong} [opt_options.matrixSet] zu verwendendes MatrixSet (erfolgt keine Angabe wird das erste vom Dienst unterstütze MatrixSet genutzt)
 */
gc.gis.map.GCAbstractWMTSProvider.prototype.getLayerConfig = gc.gis.abstractMethod;
